module.exports = __webpack_public_path__ + "media/images/free_preview_landscape-cf78c96e70c1be904ee66ff0c69acb92.png";